import GetIntegrationStore from '../routers/IntegrationControl/store/GetIntegrationStore';
import { sourceImages } from '../components/sharedComponets/PieChartAm/Children/souceData';
import { integrationImages, authIntegrationImages } from '../routers/IntegrationControl';

function getPlatformImages() {
	const response = GetIntegrationStore.getResponse();
	if (!response) return {};
	// Support both a top-level `platformImages` field and one nested under
	// `whiteLabelImages`, in case the API shape differs by response context.
	return response.platformImages || (response.whiteLabelImages && response.whiteLabelImages.platformImages) || {};
}

// Cache-bust API-uploaded images so a re-upload shows up immediately instead
// of the browser serving a stale cached copy of the same URL.
function withTimestamp(url) {
	if (!url) return url;
	return `${url}${url.includes('?') ? '&' : '?'}time=${Date.now()}`;
}

// Small icon-style source image (review row icons, chart bullets, etc).
// Prefers the admin-uploaded image (Platform Images > Source Icons) over the
// hardcoded default.
export function getSourceIcon(key) {
	const platformImages = getPlatformImages();
	const apiIcon = platformImages.sourceIcon && platformImages.sourceIcon[key];
	return apiIcon ? withTimestamp(apiIcon) : sourceImages[key];
}

// Wordmark/logo-style source image (Integrations toggle lists).
// Prefers the admin-uploaded image (Platform Images > Source Logos) over the
// hardcoded default.
export function getSourceLogo(key) {
	const platformImages = getPlatformImages();
	const apiLogo = platformImages.sourceLogo && platformImages.sourceLogo[key];
	if (apiLogo) return withTimestamp(apiLogo);
	return authIntegrationImages[key] || integrationImages[key];
}

// Payment method card_type values (e.g. from Stripe/Chargebee, snake_case)
// mapped to the camelCase keys used by Platform Images > Payment Logos.
const CARD_TYPE_TO_PAYMENT_KEY = {
	visa: 'visaCard',
	mastercard: 'mastercard',
	jcb: 'jcbCard',
	american_express: 'americanExpress',
	diners_club: 'dinersClub',
	cmr_falabella: 'cmrFalabella',
	tarjeta_naranja: 'tarjetaNaranja',
	cencosud: 'cencosud',
	cabal: 'cabal',
	argencard: 'argencard',
	elo: 'elo',
	hipercard: 'hipercard',
	rupay: 'rupay',
	maestro: 'maestro',
};

// Payment card logo (Workspace/Account billing sections, etc).
// Prefers the admin-uploaded image (Platform Images > Payment Logos) over the
// given hardcoded fallback map (keyed by the raw card_type string).
export function getPaymentLogo(cardType, fallbackMap) {
	const platformImages = getPlatformImages();
	const normalized = cardType && cardType.toLowerCase();
	const paymentKey = normalized && CARD_TYPE_TO_PAYMENT_KEY[normalized];
	const apiLogo = paymentKey && platformImages.paymentLogo && platformImages.paymentLogo[paymentKey];
	if (apiLogo) return withTimestamp(apiLogo);
	return fallbackMap && normalized && fallbackMap[normalized];
}
